<!-- カテゴリナビバー および カテゴリの並べ替え -->
<template>
  <nav v-if="isShowNavBar">
    <div class="crly-o-contents-nav swiper-container">
      <CrlyMoleculesContentsCategoryList
        :itemList="navItemList"
        :type="getType"
      />
      <CrlyAtomsContentsSettingBtn @clickNavSettingBtn="clickNavSettingBtn" />
      <CrlyMoleculesContentsSettingMenu
        :showSettingMenu="showSettingMenu"
        :itemList="navItemList"
        @clickNavSettingCloseBtn="hideNavSetting"
        @clickCompleteBtn="clickCompleteBtn"
        :showMenu="showMenu"
      />
    </div>
  </nav>
</template>

<script>
import CrlyAtomsContentsSettingBtn from "@crly/components/atoms/contents/SettingBtn.vue";
import CrlyMoleculesContentsSettingMenu from "@crly/components/molecules/contents/SettingMenu.vue";
import CrlyMoleculesContentsCategoryList from "@crly/components/molecules/contents/CategoryList.vue";

export default {
  name: "CrlyOrganismsContentsNavBar",
  components: {
    CrlyAtomsContentsSettingBtn,
    CrlyMoleculesContentsSettingMenu,
    CrlyMoleculesContentsCategoryList
  },
  props: {
    /**
     * カテゴリ
     */
    //    type: { type: String, default: "" },
    showMenu: {
      type: Boolean,
      default: false
    }
  },
  /**
   * ハンバーガーメニューが押下された場合非表示
   */
  watch: {
    showMenu(status) {
      if (status == false) {
        this.$store.commit("menuStatus/setCategoryMenu", false);
        this.showSettingMenu = status;
      }
    },
    type(next) {
      if (next == "") {
        this.$store.commit("menuStatus/setCategoryMenu", false);
        this.showSettingMenu = false;
      }
    }
  },
  data: () => ({
    /**
     * 並び順の設定
     */
    orderList: [],
    /**
     * 並び替え後の一覧
     */
    navItemList: [],
    /**
     * 並び替えメニューの表示状態
     */
    showSettingMenu: false
  }),
  methods: {
    /**
     * 現在の並び順を取得する
     */
    getCurrentOrder() {
      let dateStorage = this.$store.getters[
        "navOrderLStorage/getLastUpdateDate"
      ];
      let dateCookie = this.$store.getters["navOrderCookie/getLastUpdateDate"];
      let orderList = null;
      if (dateCookie) {
        if (!dateStorage || dateCookie > dateStorage) {
          // クッキーの方が新しいorローカルストレージに情報が無い
          // ⇒クッキーの内容でローカルストレージを上書き
          orderList = this.$store.getters["navOrderCookie/getOrder"];
          this.$store.commit("navOrderLStorage/setOrder", orderList);
          this.$store.commit("navOrderLStorage/setLastUpdateDate", dateCookie);
        } else {
          // クッキーの方が古い
          // ⇒クッキーをローカルストレージの内容で上書き（ローカルストレージの日時）
          orderList = this.$store.getters["navOrderLStorage/getOrder"];
          this.$store.commit("navOrderCookie/setOrder", orderList);
          this.$store.commit("navOrderCookie/setLastUpdateDate", dateStorage);
        }
      } else {
        // クッキーに情報が無い場合
        if (!dateStorage) {
          // ローカルストレージに情報が無い場合
          // ⇒デフォルトの並び順を表示
          orderList = this.CONST.NAV_ORDER_DEFAULT;
        } else {
          // ローカルストレージに情報がある場合
          // ⇒クッキーにローカルストレージの内容を書き込み（ローカルストレージの日時）
          orderList = this.$store.getters["navOrderLStorage/getOrder"];
          this.$store.commit("navOrderCookie/setOrder", orderList);
          this.$store.commit("navOrderCookie/setLastUpdateDate", dateStorage);
        }
      }
      // 万が一リスト取得できない場合は最悪デフォルトを表示する
      if (!orderList || orderList.length <= 0) {
        console.log("カテゴリリスト取得失敗");
        orderList = this.CONST.NAV_ORDER_DEFAULT;
      }      
      this.orderList = orderList;
    },
    /**
     * Navアイテムを並び変える
     */
    sortNavItem() {
      let navItemList = [];
      const len = this.orderList.length;
      for (let i = 0; i < len; i++) {
        navItemList.push(this.CONST_NAV_ITEM[this.orderList[i]]);
      }
      this.navItemList = navItemList;
    },
    /**
     * 設定ボタンのクリックイベント
     */
    clickNavSettingBtn() {
      this.showSettingMenu = true;
    },
    /**
     * 並び替え完了クリックイベント
     */
    clickCompleteBtn(list) {
      this.navItemList = list.concat();
      this.showSettingMenu = false;
      this.$store.commit("menuStatus/setCategoryMenu", false);
      this.makeCurrentOrderList();
    },
    /**
     * 並び替え画面を閉じる
     */
    hideNavSetting() {
      this.showSettingMenu = false;
      this.$store.commit("menuStatus/setCategoryMenu", false);
    },    
    /**
     * 一覧の並び順を作成する
     */
    makeCurrentOrderList() {
      const len = this.navItemList.length;
      let orderList = [];
      for (let i = 0; i < len; i++) {
        orderList.push(this.navItemList[i].key);
      }
      let dt = new Date();
      this.$store.commit("navOrderCookie/setOrder", orderList);
      this.$store.commit("navOrderLStorage/setOrder", orderList);
      this.$store.commit("navOrderCookie/setLastUpdateDate", dt.getTime());
      this.$store.commit("navOrderLStorage/setLastUpdateDate", dt.getTime());
    },
    /**
     * 画面pathを取得する
     */
    getWindowPath() {
      console.log("■this.$router.path", this.$route.path);
      return this.$route.path;
    }
  },
  mounted() {
    this.getCurrentOrder();
    this.sortNavItem();
  },
  computed: {
    /**
     * 検索対象の大カテゴリから、選択状態にするカテゴリアイコンを取得
     */
    getType() {
      return "travel";
    },
    /**
     * 本カテゴリナビバーを表示するか否か
     * ※メニュー一覧画面の場合のみ表示
     */
    isShowNavBar() {
      if (this.getWindowPath() == "/search/menu") {
        return true;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/organisms/contents/navBar.scss";
</style>
